import React, { useState, lazy, Suspense } from 'react';

// Comps
import AccountSectionLayout from '@project-stories/ecommerce/Account/AccountSectionLayout';
import AccountOrders from '@project-stories/ecommerce/Account/AccountOrders/AccountOrders';
const AccountOrder = lazy(() => import('@project-stories/ecommerce/Account/AccountOrders/AccountOrder'));

// Styles
import './account-orders.scss';

const AccountOrdersLanding = ({ orders, locales }) => {
  const [activeOrder, setActiveOrder] = useState(null);

  const handleClickOrder = (event: React.ClickEvent<HTMLLinkElement>, order: any) => {
    event.preventDefault();

    setActiveOrder(order);
  };

  return (
    <AccountSectionLayout classes={`lg:pl-[98px] md:mt-8 max-h-[900px] min-h-[400px] h-[80vh] overflow-y-auto`}>
      <div className={'pb-3 overflow-x-auto'}>
        {activeOrder ? (
          <Suspense>
            <AccountOrder
              order={activeOrder}
              onClickClose={() => setActiveOrder(null)}
              locales={locales.order}
            />
          </Suspense>
        ) : (
          <AccountOrders
            orders={orders}
            onClickOrder={handleClickOrder}
            locales={locales.orders}
          />
        )}
      </div>
    </AccountSectionLayout>
  );
};

export default AccountOrdersLanding;
